import styled from 'styled-components';

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const OptOutRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const OptOutCopy = styled.div`
  display: flex;
  flex-direction: column;
`;
